/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Preview_Hero_HintInputs */

const cs_templates_preview_hero_hint = /** @type {(inputs: Templates_Preview_Hero_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled z ukázkových dat (bez kreditů).`)
};

const en_templates_preview_hero_hint = /** @type {(inputs: Templates_Preview_Hero_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview from sample data (no credits).`)
};

/**
* | output |
* | --- |
* | "Preview from sample data (no credits)." |
*
* @param {Templates_Preview_Hero_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_preview_hero_hint = /** @type {((inputs?: Templates_Preview_Hero_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Preview_Hero_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_preview_hero_hint(inputs)
	return cs_templates_preview_hero_hint(inputs)
});